import { useState, useEffect } from 'react';
import Iconify from './Iconify';
import { cn } from '../utils/utils';

const MAX_MODELS = 2;

export default function ModelNavigation({ isModelOpen = false, onModelChange }) {
  const [activeModel, setActiveModel] = useState(1);
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleModelChange = (newModel) => {
    if (isTransitioning) return;

    setIsTransitioning(true);
    setActiveModel(newModel);
    onModelChange(newModel);

    // Reset transition lock after animation completes
    setTimeout(() => {
      setIsTransitioning(false);
    }, 600);
  };

  const handleNextModel = () => {
    if (activeModel < MAX_MODELS) {
      handleModelChange(activeModel + 1);
    }
  };

  const handlePreviousModel = () => {
    if (activeModel > 1) {
      handleModelChange(activeModel - 1);
    }
  };

  return (
    <div
      className={cn(
        'text-white pointer-events-auto w-full max-w-[212px] lg:max-w-[381px]',
        // isModelOpen ? 'opacity-0 pointer-events-none' : 'opacity-100 pointer-events-auto',
      )}
    >
      <div className="flex items-center gap-4">
        <p className="tracking-widest text-white select-none text-[10px]/[16px] lg:text-[14px]/[22px] flex items-center gap-2 max-w-[80px] w-full">
          <span className="font-medium max-w-[2ch] w-full">0{activeModel}</span>
          <span className="flex-shrink-0 text-white">
            {' '}
            / {MAX_MODELS.toString().padStart(2, '0')}
          </span>
        </p>

        <div className="w-full max-w-[110px] lg:max-w-[200px] relative">
          <div className="absolute inset-0 bg-white h-[0.5px]"></div>
          <div
            className="absolute bg-white h-[3px] translate-y-[-1px] transition-all duration-300"
            style={{ width: `${(activeModel / MAX_MODELS) * 100}%` }}
          ></div>
        </div>

        <div className="flex items-center">
          <button
            className={cn(
              'p-2 transition-colors duration-300 rounded-full',
              activeModel > 1 ? 'hover:bg-white/20' : 'opacity-50 cursor-not-allowed',
            )}
            onClick={handlePreviousModel}
            disabled={activeModel === 1 || isTransitioning}
          >
            <Iconify icon="mdi:chevron-left" className="text-white size-4 lg:size-6" />
          </button>
          <button
            className={cn(
              'p-2 transition-colors duration-300 rounded-full',
              activeModel < MAX_MODELS
                ? 'hover:bg-white/20'
                : 'opacity-50 cursor-not-allowed',
            )}
            onClick={handleNextModel}
            disabled={activeModel === MAX_MODELS || isTransitioning}
          >
            <Iconify icon="mdi:chevron-right" className="text-white size-4 lg:size-6" />
          </button>
        </div>
      </div>
    </div>
  );
}
